import { axiosGet } from '../ServiceBase.js';

export const findAutorizacionesAmbulatorias = async () => {
  return axiosGet('/v1/autorizaciones/ambulatorias');
};

export const getAutorizacionAmbulatoria = async (id = 0) => {
  return axiosGet(`/v1/autorizaciones/ambulatorias/${id}`);
};
